import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { ChartPie } from "./chart";
import "../../style.css";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Routes {
  data: {
    collects: {
      status: string;
      qtd: string;
    }[];
  };
}

export const ChartSchedulingCollectsDocuments = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { id, shortToken , mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);
  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    collects: [{ status: "", qtd: "" }],
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/documents/collects?graphic_id=chartSchedulingCollectsDocuments&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/documents/collects?graphic_id=chartSchedulingCollectsDocuments&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((documents: Routes) => {
        setRoutes(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-scheduling-collects-documents" className="h100">
      <ChartPie data={routes} />
    </div>
  ) : (
    <LoadingGraphics />
  );
};
